import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Header = _resolveComponent("Header");

  var _component_router_view = _resolveComponent("router-view");

  var _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock(_Fragment, null, [$setup.showCompoents ? (_openBlock(), _createBlock(_component_Header, {
    key: 0
  })) : _createCommentVNode("", true), _createVNode(_component_router_view), $setup.showCompoents ? (_openBlock(), _createBlock(_component_Footer, {
    key: 1
  })) : _createCommentVNode("", true)], 64);
}